import { Injectable, Pipe, PipeTransform } from '@angular/core';
// import { OnecartAppInitializerService } from 'modules/onecart/services/onecart-app-initializer.service';
import { AppInitializerService } from 'app/app-initializer.service';

@Pipe({ name: 'azureBlobToken' })
@Injectable({
  providedIn: 'root',
})
export class AzureTokenBlobPipe implements PipeTransform {
  constructor(private appInit: AppInitializerService) {}

  // transform(imgUrl: string) {
  //   let imagePath = '';
  //   imagePath = imgUrl;
  //   console.log(this.appInit.azureBlobTokenKey);
  //   if (imagePath && this.appInit.azureBlobTokenKey) {
  //     let arr = imagePath.split('?');
  //     if (arr.length > 1) {
  //       imagePath = imagePath + '&' + this.appInit.azureBlobTokenKey;
  //     } else {
  //       imagePath = imagePath + '?' + this.appInit.azureBlobTokenKey;
  //     }
  //   }

  //   return imagePath;
  // }

  transform(url: string, ...args: any[]): any {
    const key = this.appInit.azureBlobTokenKey;

    if (url && key) {
      url = url.includes('?') ? url.concat('&', key) : url.concat('?', key);
    }
    return url;
  }
}
